<style>
.edi-allorderbill .filter .ui-search-input-l {
    width: 100%;
}
</style>
<template>
<div class="edi-allorderbill">
	<navbar title="单据统计-流水"></navbar>
	<div class="common-scroll" id="common-scroll" @scroll="refresh">
		<div class="filter">
			<input type="text" v-model="text" class="ui-search-input ui-search-input-l"  @keyup.enter="search"/>
		</div>
		<div class="container">
			<ul class="ui-listview">
				<li v-for="billCountSerial in billCountSerials">
					<router-link :to="{ path: '/bill-count-serial-detail', query: { bill_id: billCountSerial.id }}">
						<p class="allorderbill-list-p">{{billCountSerial.restaurant_name}}
							<span v-if="billCountSerial.bill_state == 10"  class="grey-font">
								<i v-if="billCountSerial.urgent_flag == 1" class="tips-flag">加急</i>未处理
							</span>
							<span v-if="billCountSerial.bill_state == 11"  class="aqua-font">
								<i v-if="billCountSerial.urgent_flag == 1" class="tips-flag">加急</i>待发货
							</span>
							<span v-if="billCountSerial.bill_state == 12"  class="orange-font">
								<i v-if="billCountSerial.urgent_flag == 1" class="tips-flag">加急</i>已发货
							</span>
							<span v-if="billCountSerial.bill_state == 13"  class="ink-font">
								<i v-if="billCountSerial.urgent_flag == 1" class="tips-flag">加急</i>已收货 未确认
							</span>
							<span v-if="billCountSerial.bill_state == 14"  class="ink-font" style="color: #70B603">
								<i v-if="billCountSerial.urgent_flag == 1" class="tips-flag">加急</i>已收货 已确认
							</span>
							<span v-if="billCountSerial.bill_state == 20"  class="grey-font">
								<i v-if="billCountSerial.urgent_flag == 1" class="tips-flag">加急</i>未确认
							</span>
							<span v-if="billCountSerial.bill_state == 21"  class="red-font">
								<i v-if="billCountSerial.urgent_flag == 1" class="tips-flag">加急</i>已确认
							</span>
						</p>
						<ul class="ui-detail-listview">
							<li>单号：{{billCountSerial.trans_bill_no}}</li>
							<li>订货日期：{{dateCut(billCountSerial.from_date)}}</li>
							<li>送往：{{billCountSerial.to_organ_name}}</li>
							<li>收货日期：{{dateCut(billCountSerial.to_date)}}</li>
							<li>订货金额：{{billCountSerial.sum_money | numFixed(numScale)}}元</li>
							<li>发货金额：{{billCountSerial.sum_money_send | numFixed(numScale)}}元</li>
							<li>实收金额：{{billCountSerial.sum_money_recipient | numFixed(numScale)}}元</li>
						</ul>
						<p class="allorderbill-total-p">共<strong>{{billCountSerial.detail_num}}</strong>种品项</p>
					</router-link>
				</li>
			</ul>
		</div>
		<refresh v-show="!shown" :cls="cls" :font="font"></refresh>
		<mid-ware v-show="midware" :icon="icon" :midFont="midFont"></mid-ware>
	</div>
	<loading v-show="loading"></loading>
</div>
</template>

<script>
import Loading from '../components/loading'
import MidWare from '../components/MidWare'
import Refresh from '../components/refresh'
import NavBar from '../components/NavBar'
export default {
	data () {
		return {
			shown: true,
			cls: '',
			font: '',
			midware: true,
			icon: '',
			midFont: '',
			text: '',
			loading: true,
			show: false,
			billCountDetails: {},
			totalSum: {},
			querySerialData: this.$route.query,
			billCountSerials: {},
			start: 0,
			length: 10,
			prevLength: 0,
			numScale: 2
		}
	},
	components: {
		'loading': Loading,
		'mid-ware': MidWare,
		'refresh': Refresh,
		'navbar': NavBar
	},
	filters: {
		// edi小数位数处理
		numFixed (val, scale) {
			// if (scale) {
			// 	return (parseFloat(val) || 0).toFixed(scale)
			// } else {
			return val
			// }
		}
	},
	methods: {
		dateCut (val) {
			var arr = val.split(' ')
			return arr[0]
		},
		search () {
			this.loading = true
			var filterData = {
				bill_state: this.querySerialData.bill_state,
				restaurant_id: this.querySerialData.restaurant_id,
				start_date: this.querySerialData.start_date,
				end_date: this.querySerialData.end_date,
				organ_id: this.querySerialData.organ_id,
				organ_type: this.querySerialData.organ_type,
				keyword: this.text,
				start: 0,
				length: 10
			}
			this.$http.post('/cldEdi/business/billList', filterData).then((response) => {
				this.loading = false
				this.billCountSerials = response.body.data
			})
		},
		refresh () {
			var el = document.getElementById('common-scroll')
			var marginBot = el.scrollHeight - (el.scrollTop + document.body.scrollTop) - el.clientHeight
			// window.console.log(marginBot)
			if (marginBot <= 1) {
				this.shown = false
				if (this.prevLength < 10) {
					this.cls = 'remind'
					this.font = '已经没有数据'
					var self = this
					setTimeout(() => {
						self.shown = true
					}, 1500)
					return false
				}
				this.cls = 'update'
				this.font = '加载中...'
				this.start ++
				var start = this.start * 10
				var filterData = {
					bill_state: this.querySerialData.bill_state,
					restaurant_id: this.querySerialData.restaurant_id,
					start_date: this.querySerialData.start_date,
					end_date: this.querySerialData.end_date,
					organ_id: this.querySerialData.organ_id,
					organ_type: this.querySerialData.organ_type,
					keyword: this.text,
					start: start,
					length: 10
				}
				this.$http.post('/cldEdi/business/billList', filterData).then((response) => {
					var data = response.body.data
					this.shown = true
					this.prevLength = data.length
					this.billCountSerials = this.billCountSerials.concat(data)
				}, (response) => {
					this.loading = false
					this.midware = true
					this.icon = 'middle-net'
					this.midFont = '服务中断，稍后请重试！'
				})
			}
		}
	},
	created () {
		this.loading = true
		var filterData = {
			bill_state: this.querySerialData.bill_state,
			restaurant_id: this.querySerialData.restaurant_id,
			start_date: this.querySerialData.start_date,
			end_date: this.querySerialData.end_date,
			organ_id: this.querySerialData.organ_id,
			organ_type: this.querySerialData.organ_type,
			keyword: '',
			start: 0,
			length: 10
		}
		this.$http.post('/cldEdi/business/billList', filterData).then((response) => {
			this.loading = false
			this.billCountSerials = response.body.data
			this.prevLength = this.billCountSerials.length
			// window.console.log(this.prevLength)
		})
	}
}
</script>



// WEBPACK FOOTER //
// BillCountSerial.vue?54343c18